import React from 'react';
import CaseStudyLayout from '@/components/CaseStudyLayout';

const MedPraxisBaselCase = () => {
  const caseStudy = {
    id: 'medpraxis-basel',
    company: 'MedPraxis Basel',
    industry: 'Gesundheitswesen',
    service: 'AI-Video Patientenaufklärung',
    duration: '4 Monate',
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    challenge: 'Die Basler Arztpraxis kämpfte mit einem vertrauensbasierten Problem: Neue Patienten zögerten bei komplexen Behandlungen, da sie die Verfahren nicht verstanden. Termine wurden oft kurzfristig abgesagt, und die Praxis hatte Schwierigkeiten, sich von Konkurrenten abzuheben. Nur 890 monatliche Website-Besucher und geringe Online-Präsenz in einer umkämpften Gesundheitsbranche.',
    solution: 'Wir erstellten personalisierte AI-Aufklärungsvideos für verschiedene Behandlungen in Deutsch, Französisch und Italienisch. Jedes Video erklärte medizinische Eingriffe verständlich und baute Vertrauen auf. Kombiniert mit lokalem SEO für "Arzt Basel" und medizinischen Fachbegriffen sowie einer mehrsprachigen Website-Optimierung.',
    results: {
      traffic: { before: '890', after: '3,200' },
      leads: { before: '12', after: '38' },
      conversion: { before: '2.1%', after: '4.6%' }
    },
    testimonial: {
      quote: 'Die AI-Videos haben unsere Patientenkommunikation revolutioniert. Komplexe Eingriffe werden jetzt verständlich erklärt, Patienten sind besser informiert und kommen entspannter zu Terminen. No-Shows sind um 60% gesunken.',
      author: 'Dr. med. Klaus Weber',
      position: 'Leiter MedPraxis Basel'
    }
  };

  return <CaseStudyLayout caseStudy={caseStudy} />;
};

export default MedPraxisBaselCase;